import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLoginModule } from './app-login/app-login.module';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment.prod';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HomeComponent } from './home/home.component';
import { AuthService, AuthServiceActivation } from './app-login/auth.service';
import { ChatService } from './main-app/chat/chat.service';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PricingComponent } from './pricing/pricing.component';
import { HomeNavigationComponent } from './home-navigation/home-navigation.component';
import { MeetOurInstructorsComponent } from './meet-our-instructors/meet-our-instructors.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TrialDialogComponent } from './trial-dialog/trial-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PricingComponent,
    HomeNavigationComponent,
    MeetOurInstructorsComponent,
    TrialDialogComponent
  ],
  imports: [
    BrowserModule,
    AppLoginModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AppRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    RouterModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    AuthService,
    AuthServiceActivation,
    ChatService
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
